import { SubmissionError } from 'redux-form';

const validateCreateForm = (values) => {

    validateTitle(values);

}

const validateTitle = (values) => {
    const { title } = values;

    if(!title) {
        throw new SubmissionError({title: "Title cannot be empty"})
    } else if(title === "test") {
        throw new SubmissionError({title: "Title cannot be empty"})
    }
}

export default validateCreateForm;